<template>
  <div class="box mt-5">
    <div class="row">
      <div class="col-md-12 m-3" style="display: flex; justify-content: space-between;">
        <div>
          <h3> 
            Passengers <ShowHideEye :showSection="showPassenger" @toggle="showPassenger = !showPassenger"/>
          </h3>
        </div>
        <!-- <div style="margin-right: 2rem;"> 
          <span><TriggerSMS :bookings="[$route.params.id]" /></span> 
        </div> -->
      </div>
    </div>
    <div class="row" v-if="showPassenger">
      <div class="col-md-12">
        <table class="table" cellspacing="0" cellpadding="0">
          <thead>
            <tr>
              <th></th>
              <th>Title</th>
              <th>First name</th>
              <th>Last name</th>
              <th>DOB</th>
              <th>Gender</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(passenger, index) of passengers">
              <tr :key="'passenger-' + passenger.id">
                <td width="5%" v-on:click="activePassenger = passenger">+</td>
                <td width="10%" ><v-select v-model="passenger.title" :options="['Mr', 'Mrs', 'Miss', 'Master', 'Ms', 'Mx', 'Dr', 'Prof']"></v-select></td>
                <td width="25%"><input style="width: 100%;" type="text" v-model="passenger.first_name"></td>
                <td width="25%"><input style="width: 100%;" type="text" v-model="passenger.last_name"></td>
                <td width="15%"><input type="date" v-model="passenger.dob"></td>
                <td width="10%"><v-select v-model="passenger.gender" :options="['Male', 'Female']"></v-select></td>
                <td width="10%" class="table-action">
                  <div class="row-actions" v-if="userRole == 1">
                    <button class="action-btn update-btn" aria-label="Update passenger details" v-on:click="updatePassenger(passenger.id)">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                          <path d="M23 4v6h-6"></path>
                          <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"></path>
                      </svg>
                      <span class="tooltip">Update passenger details</span>
                    </button>

                    <button class="action-btn delete-btn" aria-label="Delete passenger" v-on:click="deletePassenger(passenger.id)">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <polyline points="3 6 5 6 21 6"></polyline>
                            <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                            <line x1="10" y1="11" x2="10" y2="17"></line>
                            <line x1="14" y1="11" x2="14" y2="17"></line>
                        </svg>
                        <span class="tooltip">Delete passenger</span>
                    </button>
                  </div>
                  <!-- <a v-on:click="deletePassenger(passenger.id)" class="icon icon--delete" v-if="userRole == 1">Delete</a>
                  <a  class="icon icon--update" v-if="userRole == 1">Delete</a> -->
                </td>
              </tr>
              <tr :key="'passport-' + passenger.id" v-if="passenger == activePassenger">
                <td colspan="7">
                  <table>
                    <tr>
                      <td>
                        <label>Passport no.</label><br>
                        <input type="text" v-model="passenger.passport_no" placeholder="Passport no.">
                      </td>
                      <td>
                        <label>Passport issued</label><br>
                        <input type="date" v-model="passenger.passport_issue">
                      </td>
                      <td>
                        <label>Passport expires</label><br>
                        <input type="date" v-model="passenger.passport_expiry">
                      </td>
                      <td>
                        <label>Passport nationality</label><br>
                        <input type="text" v-model="passenger.passport_nationality" placeholder="Passport nationality">
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <label>Policy Number</label><br>
                        <input type="text" v-model="passenger.policy_number" placeholder="Policy Number">
                      </td>
                      <td>
                        <label>Insurance Company</label><br>
                        <input type="text" v-model="passenger.insurance_company" placeholder="Insurance Company">
                      </td>
                      <td>
                        <label>24hr. Insurer Telephone Number </label><br>
                        <input type="text" v-model="passenger.insurance_telephone_number" placeholder="24hr. Insurer Telephone Number">
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
            </template>
            <tr style="background-color: #FCFCFE;" v-if="userRole == 1">
              <td width="5%"></td>
              <td width="10%"><v-select v-model="newPassenger.title" :options="['Mr', 'Mrs', 'Miss', 'Master', 'Ms', 'Mx', 'Dr', 'Prof']"></v-select></td>
              <td width="25%"><input style="width: 100%;" type="text" v-model="newPassenger.first_name"></td>
              <td width="25%"><input style="width: 100%;" type="text" v-model="newPassenger.last_name"></td>
              <td width="15%"><input type="date" v-model="newPassenger.dob"></td>
              <td width="10%"><v-select v-model="newPassenger.gender" :options="['Male', 'Female']"></v-select></td>
              <td width="10%" class="table-action"><button class="button button--small" v-on:click="addPassenger()">Add</button></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <!-- / box -->
</template>

<script>
import ShowHideEye from "./ShowHideEye.vue";
// import TriggerSMS from "./TriggerSMS.vue";

export default {
  name: 'BookingPassengers',
  components: {
    ShowHideEye,
    // TriggerSMS
  },
  props: {
    passengers: Array,
  },
  created() {
    this.userRole
  },
  computed : {
    userRole() {
      let user_role = localStorage.getItem("user_role");
      if (user_role == 1) {
        this.showPassenger = true
      }
      return user_role
    }
  },
  data () {
    return {
      newPassenger: {
        holiday_booking_id: this.$route.params.id
      },
      activePassenger: null,
      showPassenger:false
    }
  },
  methods: {
    addPassenger () {
      
      let pessengerDetails = {
        passenger : this.newPassenger
      }

      // API Caall for Update Pessenger in Booking
      this.$store.dispatch('setLoadStatus')

      fetch(`${this.$api}update-booking/update-pessenger`, {
        method: 'POST',
        body: JSON.stringify(pessengerDetails),
        headers: {
          "Content-Type": "application/json",
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(res => res.json())
      .then(response => {
        
        this.$store.dispatch('setLoadStatus')
        
        if (response.status) {

          this.$emit('update-passenger-list',  response.passenger_list);
          this.newPassenger = {
            holiday_booking_id: this.$route.params.id
          }
          
        }
        
      })

    },
    updatePassenger(passenger_id) {
      
      let pessengerDetails = this.passengers.find(passenger => passenger.id == passenger_id)
      
      // API Caall for Deleting Pessenger in Booking
      this.$store.dispatch('setLoadStatus')

      fetch(`${this.$api}update-booking/update-pessenger-detail`, {
        method: 'POST',
        body: JSON.stringify({
         ...pessengerDetails
        }),
        headers: {
          "Content-Type": "application/json",
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(res => res.json())
      .then(response => {
        this.$store.dispatch('setLoadStatus')
        if (response.status) {
          this.$notify({
            type: 'success',
            title: response.message
          });
          this.$emit('handleBooking')
        }
      })
    },
    deletePassenger(passenger_id) {
      // this.passengers.splice(index, 1);
      
      // API Caall for Deleting Pessenger in Booking
      this.$store.dispatch('setLoadStatus')

      fetch(`${this.$api}update-booking/remove-passenger/${passenger_id}`, {
          method: 'POST',
          body: JSON.stringify({
            holiday_booking_id:this.$route.params.id
          }),
          headers: {
            "Content-Type": "application/json",
            'Accept': 'application/json',
            'Authorization': localStorage.getItem('token')
          }
        })
        .then(res => res.json())
        .then(response => {
          
          this.$store.dispatch('setLoadStatus')
          
          if (response.status) {
            // this.passengers = response.passenger_list
            this.$emit('update-passenger-list',  response.passenger_list);
          }
        })
    }
  }
}
</script>
<style scoped>
.row-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.action-btn {
  width: 32px;
  height: 32px;
  border: none;
  background-color: transparent;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
  transition: background-color 0.2s ease;
}

.action-btn:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

.action-btn svg {
  width: 18px;
  height: 18px;
  stroke: #6B7280;
  transition: stroke 0.2s ease;
}

.update-btn:hover svg {
  stroke: #2563EB;
}
.delete-btn:hover svg {
  stroke: #DC2626;
}

.action-btn .tooltip {
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  background-color: #1F2937;
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.2s ease, visibility 0.2s ease;
}

.action-btn:hover .tooltip {
  opacity: 1;
  visibility: visible;
}
</style>